import { sessionReplayPlugin } from "@amplitude/plugin-session-replay-browser";
import { datadogLogs } from "@datadog/browser-logs";
import ReactGA from "react-ga4";
import TagManager from "react-gtm-module";
import { getSiteValueByLocaleId } from "../utils/SiteUtils";
export const setupExternalServices = () => {
	setAmplitude(null);
	setGoogleAnalytics();
};
export const setupExternalServicesWithUser = (user) => {
	const {
		id: userId,
		email: userEmail,
		firstName: userName,
		phone: userPhone,
	} = user;
	setAmplitude(userId);
	setTagManager(userId, userEmail, userName, userPhone);
	setDataDog(userId, userEmail);
};
const setAmplitude = (userId) => {
	if (window.amplitude) {
		window.amplitude.add(
			sessionReplayPlugin({
				debugMode: process.env.REACT_APP_ENVIRONMENT !== "production",
			}),
		);
		window.amplitude.setUserId(userId);
	}
};
const setGoogleAnalytics = () => {
	const gaMeasurementId = getSiteValueByLocaleId("gaMeasurementId");
	ReactGA.initialize(gaMeasurementId);
};
const setDataDog = (userId, userEmail) => {
	datadogLogs.init({
		clientToken: "pubfe3de757580b6543d9d5412bb7f0fb22",
		site: "datadoghq.com",
		forwardErrorsToLogs: true,
		forwardConsoleLogs: ["log", "error"],
		sessionSampleRate: 100,
		service: "plt-web",
		env: process.env.REACT_APP_ENVIRONMENT,
	});
};
const setTagManager = (userId, userEmail, userName, userPhone) => {
	const tagManagerArgs = {
		gtmId: process.env.REACT_APP_GTM_ID,
		auth: process.env.REACT_APP_GTM_ENV_AUTH,
		preview: process.env.REACT_APP_GTM_ENV_PREVIEW,
		dataLayer: {
			user: {
				id: userId,
				email: userEmail,
				name: userName,
				phone: userPhone,
			},
			nodeEnv: process.env.NODE_ENV,
		},
	};
	TagManager.initialize(tagManagerArgs);
};
